/**  Actions for managing user dataa  */
import Zergling from '../helpers/zergling';
import {UILoading, UILoadingDone, UILoadingFailed} from "./ui";
import formsNames from "../constants/formsNames";
import {USER_PROFILE_UPDATE_RECEIVED, UPDATE_MESSAGES_UNREAD_COUNT, FINISH_REGISTRATION} from "./actionTypes/index";

/**
 * @description Sync action creator
 * @param data profile data(full, not just the diff)
 * @returns {{type, payload: *}} action object
 */
export const UserProfileUpdateReceived = (data) => {
    return {
        type: USER_PROFILE_UPDATE_RECEIVED,
        payload: data
    };
};
/**
 * @description Async action creator for resetting user password.
 * @param {String} email email to send password to
 * @returns {Function} function to be executed by redux thunk middleware
 */
export function ResetPassword (email) {
    return function (dispatch) {
        dispatch(UILoading(formsNames.resetPasswordForm));
        return Zergling
            .get({email}, 'forgot_password')
            .then((response) => {
                if (response.result === 0) {
                    dispatch(UILoadingDone(formsNames.resetPasswordForm));
                } else {
                    throw response; //forgot_password command returns success code even when resetting fails
                }
            })
            .catch((reason) => {
                dispatch(UILoadingFailed(formsNames.resetPasswordForm, reason));
            });
    };
}

export function FinishRegistration (payload) {
    return {
        type: FINISH_REGISTRATION,
        payload
    };
}

export function VerifyUserByEmail ({successCallback, errorCallback, params}) {
    return Zergling.get({ "verification_code": params.code }, 'verify_user').then(function (response) {
        if (response.result === 0) {
            successCallback && successCallback();
        } else {
            errorCallback && errorCallback();
        }
    });
}

export const UpdateMessagesUnreadCount = (payload) => {
    return {
        type: UPDATE_MESSAGES_UNREAD_COUNT,
        payload
    };
};

export const SubscribeForMessages = (callback) => (dispatch) => {
    Zergling
        .subscribe({'source': 'messages', 'what': {'messages': []}, 'subscribe': true}, () => {
            dispatch(UpdateMessagesUnreadCount(1));
        })
        .then((result) => {
            callback && callback(() => Zergling.unsubscribe([result.subid]).catch((ex) => console.warn("cannot unsubscribe:", ex)));
        });
};